import React, { Component } from 'react';

const Footer = (props) => {
    return (
    <footer className="page-footer text-center" style={{position:'absolute', bottom:'0', width:'99%', height:'4.5rem'}}> 
    <h5>
    © כל הזכיויות שמורות למדינת ישראל, משרד הביטחון.
    </h5>
    <h5>
      המערכת פותחה על-ידי אגף תקשוב, משהב"ט - גרסה 1.0 - 2020
    </h5>
    </footer>);
  };
  
  export default Footer;